export default "__VITE_ASSET__o8jVS$RS__"